module.exports = __webpack_public_path__ + "img/apv_logo.a1f089e8.png";